export const uid = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

export const withKey = (o) => ({ ...o, _k: o._k || uid() });

export const stripKey = ({ _k, ...rest }) => rest;
